module.exports = __webpack_public_path__ + "static/media/loc3_img14.704c8c28.jpg";